<template>
  <div class="page-content">




    <v-row>
      <v-col cols="12" sm="12" >
        <h1 class="page-title"> <span >{{$t('supportedPlatforms.pageHeader')}}</span></h1>

      </v-col>

    </v-row>


    <v-card
            class="pa-4 stats-card "
            style="border:5px;height:auto;"


    >
      <p class="card-body " style="font-size:14px;" v-html="$t('supportedPlatforms.pageSubtitle')">

      </p>
    </v-card>


   <br><br>
   <div style="text-align:right;"> <v-icon color="#444">mdi-check-bold</v-icon> {{$t('supportedPlatforms.supported')}} &nbsp; |  <v-icon color="#444">mdi-close-thick</v-icon> {{$t('supportedPlatforms.not_supported')}} | <v-icon color="#444">mdi-minus-thick</v-icon> {{$t('supportedPlatforms.not_applicable')}}</div>

    <br><br>
    <router-link  class="" style="color: rgba(0, 0, 0, 0.87);text-decoration: none; "  :to="{ path: 'vpn-for-stadia', params: { lang: this.$i18n.locale }}"> <h3>   <img  :src="stadiaSVG" class="text-action header-icon  rtl" style="width:20px;top:0;"/> {{$t('supportedPlatforms.title_stadia')}}</h3></router-link>
    <br>
    <v-data-table
            dense
            :headers="headers"
            :items="stadiaTableItems"
            item-key="name"
            hide-default-footer
            class="elevation-1"
    >
      <template v-slot:item.desktop_app="{ item }">
        <v-icon v-if="item.desktop_app==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_app==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_app==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.desktop_browser="{ item }">
        <v-icon v-if="item.desktop_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_app_and_tv="{ item }">
        <v-icon v-if="item.android_app_and_tv==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_app_and_tv==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_app_and_tv==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_browser="{ item }">
        <v-icon v-if="item.android_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.iOS="{ item }">
        <v-icon v-if="item.iOS==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.iOS==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.iOS==='X'" color="#444">mdi-close</v-icon>
      </template>

    </v-data-table>

    <br><br>
    <router-link  class="" style="color: rgba(0, 0, 0, 0.87);text-decoration: none; "  :to="{ path: 'vpn-for-geforce-now', params: { lang: this.$i18n.locale }}">  <h3><img  :src="geforceNowSVG" class="text-action header-icon  rtl"
    />{{$t('supportedPlatforms.title_geforce')}}</h3></router-link>
    <br>
    <v-data-table
            dense
            :headers="headers"
            :items="geforceTableItems"
            item-key="name"
            class="elevation-1"
            hide-default-footer
    >

      <template v-slot:item.desktop_app="{ item }">
        <v-icon v-if="item.desktop_app==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_app==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_app==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.desktop_browser="{ item }">
        <v-icon v-if="item.desktop_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_app_and_tv="{ item }">
        <v-icon v-if="item.android_app_and_tv==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_app_and_tv==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_app_and_tv==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_browser="{ item }">
        <v-icon v-if="item.android_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.iOS="{ item }">
        <v-icon v-if="item.iOS==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.iOS==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.iOS==='X'" color="#444">mdi-close</v-icon>
      </template>

    </v-data-table>

    <br><br>
    <router-link  class="" style="color: rgba(0, 0, 0, 0.87);text-decoration: none; "  :to="{ path: 'vpn-for-xcloud', params: { lang: this.$i18n.locale }}"> <h3><img  :src="gamePassSVG" class="text-action header-icon  rtl"
    />{{$t('supportedPlatforms.title_xcloud')}}</h3> </router-link>
    <br>
    <v-data-table
            dense
            :headers="headers"
            :items="xcloudTableItems"
            item-key="name"
            class="elevation-1"

            hide-default-footer
    >

      <template v-slot:item.desktop_app="{ item }">
        <v-icon v-if="item.desktop_app==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_app==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_app==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.desktop_browser="{ item }">
        <v-icon v-if="item.desktop_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.desktop_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.desktop_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_app_and_tv="{ item }">
        <v-icon v-if="item.android_app_and_tv==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_app_and_tv==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_app_and_tv==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.android_browser="{ item }">
        <v-icon v-if="item.android_browser==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.android_browser==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.android_browser==='X'" color="#444">mdi-close</v-icon>
      </template>
      <template v-slot:item.iOS="{ item }">
        <v-icon v-if="item.iOS==='V'" color="#444">mdi-check</v-icon>
        <v-icon v-if="item.iOS==='-'" color="#444">mdi-minus</v-icon>
        <v-icon v-if="item.iOS==='X'" color="#444">mdi-close</v-icon>
      </template>

    </v-data-table>


    <br><br>    <br><br>

  </div>
</template>

<style>

  .header-icon {
    width: 24px; position: relative; top: 5px; margin-right: 10px;
  }

  .stats-card {

    height:120px;
    color:#fff;
    padding:0px 5px;

  }
  .gradient-box {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 90%;
    margin: auto;
    max-width: 22em;
    position: relative;
    padding: 30% 2em;
    box-sizing: border-box;
    color: #FFF;
    background: #000;
    background-clip: padding-box;
    /* !importanté */
    border: solid 5px transparent;
    /* !importanté */
    border-radius: 1em;
  }
  .gradient-box:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -5px;
    /* !importanté */
    border-radius: inherit;
    /* !importanté */
    background: -webkit-gradient(linear, left top, right top, from(red), to(orange));
    background: linear-gradient(to right, red, orange);
  }
  .muted-title{
    color:#ceceec;
  }

  .overline{
    color:#8898aa;
  }

  .childWrap {
    /*float: left;*/

    /*background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%)!important;*/
  }




  .text-action {

    color: #EF44AE;
    background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

  }

  .page-title {
    font-weight:300;font-size:27px;margin-top:5px;margin-bottom:15px;
  }

  .mobile .page-title {
    text-align: center;
  }

</style>

<script>


  export default {
    name: 'supported-platforms',
    data: () => ({
      stadiaSVG: 'data:image/svg+xml;base64,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',
      gamePassSVG: 'data:image/svg+xml;base64,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',
      geforceNowSVG: 'data:image/svg+xml;base64,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',
      stadiaTableItems: [
        {
          name: 'GameEnable Android app',
          desktop_app: '-',
          desktop_browser: '-',
          android_app_and_tv: 'V',
          android_browser: 'X',
          iOS: '-',
        },
        {
          name: 'GameEnable Chrome extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable Edge extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable DNS',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: 'V',
          android_browser: 'V',
          iOS: 'V',
        }
      ],
      geforceTableItems: [
        {
          name: 'GameEnable Android app',
          desktop_app: '-',
          desktop_browser: '-',
          android_app_and_tv: 'V',
          android_browser: 'X',
          iOS: '-',
        },
        {
          name: 'GameEnable Chrome extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable Edge extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable DNS',
          desktop_app: 'V',
          desktop_browser: 'V',
          android_app_and_tv: 'V',
          android_browser: 'V',
          iOS: 'V',
        }
      ],
      xcloudTableItems: [
        {
          name: 'GameEnable Android app',
          desktop_app: '-',
          desktop_browser: '-',
          android_app_and_tv: 'V',
          android_browser: 'X',
          iOS: '-',
        },
        {
          name: 'GameEnable Chrome extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable Edge extension',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: '-',
          android_browser: '-',
          iOS: '-',
        },
        {
          name: 'GameEnable DNS',
          desktop_app: '-',
          desktop_browser: 'V',
          android_app_and_tv: 'V',
          android_browser: 'V',
          iOS: 'V',
        }
      ],
      headers: [
        {
          text: 'Client / Device',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Desktop App', value: 'desktop_app' },
        { text: 'Desktop Browser', value: 'desktop_browser' },
        { text: 'Android App & TV', value: 'android_app_and_tv' },
        { text: 'Android Browser', value: 'android_browser' },
        { text: 'iOS', value: 'iOS' }

      ],
    }),
    computed: {

    }
  };
</script>
